import * as React from 'reactn';
import {ComponentFactory, dialog, IBaseDialogProps} from "oca-lib-web";
import Constants from "../util/Constants";
import { LinkedIn } from 'react-linkedin-login-oauth2';
//import FacebookLogin from 'react-facebook-login';
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
    param:any,
}

class DatasourceDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let param = props.param;
        console.log(param);
        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, param.params ? JSON.parse(param.params) : null);
        componentFactory.setHandleUpdateCallback((value:any, key:string) => { this.forceUpdate() });

        console.log(componentFactory.getDefaultBinding().item);

        this.state = {
            componentFactory:componentFactory,
            param:param
        };

        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        let dataSource:DataSourceInput = {
            id:this.state.param.id,
            projectId:this.state.param.projectId,
            params: JSON.stringify(componentBinding.item)
        }
        //if (this.state.param.dataSource?.id) {
            //dataSource["id"] = this.state.param.dataSource?.id
        //}
        dataSource["dataSourceName"] = componentBinding.getProperty("dataSource");
        console.log(dataSource);

        // TODO: saveBinding?
        await this.global.dataManager.save("createDataSource", dataSource);
        callback(componentBinding.item);
    }

    public renderAppStoreConnect() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("appleBundleId","Bundle ID")),
            cf.renderBoxPadded(cf.renderTextField("appleAppId","App ID")),
            cf.renderBoxPadded(cf.renderTextField("appleId","Apple ID")),
            cf.renderBoxPadded(cf.renderTextField("applePassword","Apple Password (App Specific)",null, null, {type:'password'})),
            cf.renderBoxPadded(cf.renderTextField("appleAccountId","Apple Account ID")),
            cf.renderBoxPadded(cf.renderTextField("appleVendorNumber","Apple Vendor Number"))
            //cf.renderBoxPadded(cf.renderTextField("appleTeamId","Apple Team ID","dataSource", null)),
            //cf.renderBoxPadded(cf.renderTextField("applePushKeyId","Apple Push Key ID","dataSource", null)),
            //cf.renderBoxPadded(cf.renderTextField("applePushPrivateKey","Apple Push Private Key","dataSource", null)),
            //cf.renderBoxPadded(cf.renderTextField("appleFlurryApiKey","Flurry API Key","dataSource", null)),
        ])
    }

    public renderFlurry() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("appleFlurryApiKey","iOS Flurry API Key")),
            cf.renderBoxPadded(cf.renderTextField("googleFlurryApiKey","Android Flurry API Key"))
        ])
    }

    public renderGoogleAnalytics() {
        const cf = this.state.componentFactory;
        return cf.renderBox(
            cf.renderBoxPadded(cf.renderTextField("googleAnalyticsViewId","View ID")),
        )
    }

    public renderGooglePlay() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("googleAppId","App ID")),
            cf.renderBoxPadded(cf.renderTextField("googleBucketName","Bucket Name")),
            cf.renderBoxPadded(cf.renderTextField("googleClientEmail","Client Email")),
            cf.renderBoxPadded(cf.renderTextField("googlePrivateKey","Private Key"))
        ])
    }

    public renderLinkedIn() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            <LinkedIn
                clientId="772vxd8ptehzmg"
                onFailure={this.handleFailure}
                onSuccess={this.handleSuccess}
                redirectUri="http://localhost:3028/linkedin"
            ></LinkedIn>
        ])
    }

    public responseFacebook(response:any) {
        console.log(response);
    }

    public renderFacebook() {
        /*const cf = this.state.componentFactory;
        return cf.renderBox([
            <FacebookLogin
                appId="352074018638897"
                autoLoad={false}
                fields="name,email,picture"
                callback={this.responseFacebook} />,
        ])*/
    }

    handleSuccess = async (data:any) => {
        console.log(data.code);
        //LocalCache.saveLocal(Constants.CACHE_LINKEDIN_AUTH_TOKEN, data.code);
        //let token = await SocialUtil.getAccessToken();
        //console.log(token);
    }

    handleFailure = (error:any) => {
        console.log(error.errorMessage);
    }

    public renderTwitter() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("twitterUserName","Twitter Username")),
        ])
    }

    public renderCustom() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("dataSourceName","Data Source Name")),
            cf.renderBoxPadded(cf.renderTextField("dataSourceUri","Data Source Uri")),
        ])
    }

    public renderForDataSource(dataSource:string) {
        if (dataSource == Constants.DATA_SOURCE_APP_STORE_CONNECT) {
            return this.renderAppStoreConnect();
        } else if (dataSource == Constants.DATA_SOURCE_FLURRY) {
            return this.renderFlurry();
        } else if (dataSource == Constants.DATA_SOURCE_GOOGLE_ANALYTICS) {
            return this.renderGoogleAnalytics();
        } else if (dataSource == Constants.DATA_SOURCE_GOOGLE_PLAY) {
            return this.renderGooglePlay();
        } else if (dataSource == Constants.DATA_SOURCE_FACEBOOK) {
            return this.renderFacebook();
        } else if (dataSource == Constants.DATA_SOURCE_LINKEDIN) {
            return this.renderLinkedIn();
        } else if (dataSource == Constants.DATA_SOURCE_TWITTER) {
            return this.renderTwitter();
        } else if (dataSource == Constants.DATA_SOURCE_CUSTOM) {
            return this.renderCustom();
        }
        return null;
    }

    public render() {
        const cf = this.state.componentFactory;
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        let dataSource = componentBinding.getProperty("dataSource");

        return cf.renderBox([
            cf.renderBoxPadded(cf.renderSelectField("dataSource", "Data Source", Constants.DATA_SOURCES)),
            this.renderForDataSource(dataSource),
            cf.renderBoxProps({marginLeft:'10px'}, cf.renderSwitchField("disabled", "Disabled"))
        ])
    }
}

export default dialog(DatasourceDialog)